import { __decorate, __metadata } from "tslib";
import { UserManager, WebStorageStateStore, User } from "oidc-client";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { PublicClientApplication, AuthenticationResult, LogLevel, } from "@azure/msal-browser";
import store from "@/store";
import { APP_API_SCOPE, APP_AUTHORITY, APP_CLIENT_ID, APP_LOGOUT_REDIRECT_URL, APP_REDIRECT_URL, VUE_APP_IDP_APP_CLIENT_ID, VUE_APP_IDP_APP_AUTHORITY, VUE_APP_IDP_APP_REDIRECT_URI, VUE_APP_IDP_APP_SILENT_REDIRECT_URI, VUE_APP_IDP_APP_POST_LOGOUT_REDIRECT_URI, VUE_APP_IDP_APP_SCOPE, } from "../../services/config";
import jwt_decode from "jwt-decode";
import router from "../../router/index";
import { IUserLoginDTO } from "../models/userLoginAnalytics/userLogin";
import service from "../../services/api.service";
const MSAL_CONFIG = {
    auth: {
        clientId: APP_CLIENT_ID,
        authority: APP_AUTHORITY,
        redirectUri: APP_REDIRECT_URL,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
    },
};
const clientApplication = new PublicClientApplication(MSAL_CONFIG);
//const settings: UserManagerSettings = {
//    userStore: new WebStorageStateStore({ store: window.localStorage }),
//    authority: 'https://localhost:5001',
//    client_id: "system1_spa_app_client",
//    redirect_uri: 'https://localhost:5005/callback.html',
//    automaticSilentRenew: true,
//    silent_redirect_uri: 'https://localhost:5005/silent-renew.html',
//    response_type: "code",
//    scope: 'openid profile System1ApiScope',
//    post_logout_redirect_uri: 'https://localhost:5005/',
//    filterProtocolClaims: true,
//};
const settings = {
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    authority: VUE_APP_IDP_APP_AUTHORITY,
    client_id: VUE_APP_IDP_APP_CLIENT_ID,
    redirect_uri: VUE_APP_IDP_APP_REDIRECT_URI,
    automaticSilentRenew: true,
    silent_redirect_uri: VUE_APP_IDP_APP_SILENT_REDIRECT_URI,
    response_type: "code",
    scope: "openid profile " + VUE_APP_IDP_APP_SCOPE,
    post_logout_redirect_uri: VUE_APP_IDP_APP_POST_LOGOUT_REDIRECT_URI,
    filterProtocolClaims: true,
};
const idpUsermanager = new UserManager(settings);
idpUsermanager.events.addUserLoaded((user) => {
    if (user) {
        AuthModule.SetUser(user);
        AuthModule.SetAuthentication(true);
    }
});
let AzureAuth = /** @class */ (() => {
    var _a, _b, _c;
    let AzureAuth = class AzureAuth extends VuexModule {
        constructor() {
            super(...arguments);
            this.tokenResult = null;
            this.loginRequest = {
                scopes: [APP_API_SCOPE],
            };
            this.logoutRequest = {
                postLogoutRedirectUri: APP_LOGOUT_REDIRECT_URL,
            };
            this.isAuthenticated = false;
            this.isExpired = false;
            this.isAboutExpired = false;
            this.authenticationResult = undefined;
            //// @Mutation
            // CheckIsTokenExpired() {
            //     const diffInMilliseconds = Math.abs(this.authenticationResult.expiresOn.getTime() - new Date().getTime());
            //     const minutes = Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000); // minutes
            //     console.log('min');
            //     console.log(minutes);
            //     if (minutes <= 0) {
            //         this.isExpired = true;
            //     }
            //     else {
            //         this.isExpired = false;
            //     }
            // }
            // get IsAboutToExpired(): boolean {
            //     const diffInMilliseconds = Math.abs(this.authenticationResult.expiresOn.getTime() - new Date().getTime());
            //     const minutes = Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000); // minutes
            //     console.log('min');
            //     console.log(minutes);
            //     if (minutes <= 2 && minutes > 0) {
            //         return true;
            //     } else {
            //         return false;
            //     }
            // }
        }
        get accessToken() {
            return (this.authenticationResult && this.authenticationResult.accessToken) ?? null;
        }
        get expiresOn() {
            return (this.authenticationResult && this.authenticationResult.expiresOn) ?? new Date();
        }
        get expiresInMinutes() {
            if (this.authenticationResult && this.authenticationResult.accessToken) {
                const diffInMilliseconds = Math.abs(this.authenticationResult.expiresOn.getTime() - new Date().getTime());
                return () => Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000); // minutes
            }
            return () => -1;
        }
        async Login() {
            await this.LoginSilent();
            const response = await clientApplication.loginPopup(this.loginRequest);
            if (response != null && response != undefined && response.account) {
                //console.log('Expired');
                //console.log(response.expiresOn);
                this.SetAuthentication(true);
                this.SetAuthenticationResult(response);
                return response;
            }
            return null;
        }
        async LoginSilent() {
            this.SetAuthentication(false);
            this.SetAuthenticationResult(null);
            let accounts = await clientApplication.getAllAccounts();
            if (accounts && accounts.length == 1) {
                const silentResponse = await clientApplication.acquireTokenSilent({
                    scopes: [APP_API_SCOPE],
                    account: accounts[0],
                });
                if (silentResponse && silentResponse.account) {
                    this.SetAuthentication(true);
                    this.SetAuthenticationResult(silentResponse);
                    return silentResponse;
                }
            }
            return null;
        }
        async Logout() {
            console.log("coming here");
            const response = await clientApplication.logout(this.logoutRequest);
            if (response != null && response != undefined) {
                return response;
            }
            return null;
        }
        SetAuthentication(isAuthenticated) {
            this.isAuthenticated = isAuthenticated;
        }
        SetAuthenticationResult(authenticationResult) {
            this.tokenResult = authenticationResult;
            this.authenticationResult = authenticationResult;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], AzureAuth.prototype, "Login", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], AzureAuth.prototype, "LoginSilent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AzureAuth.prototype, "Logout", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AzureAuth.prototype, "SetAuthentication", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof AuthenticationResult !== "undefined" && AuthenticationResult) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], AzureAuth.prototype, "SetAuthenticationResult", null);
    AzureAuth = __decorate([
        Module({ dynamic: true, store: store, name: "azureauth", namespaced: true })
    ], AzureAuth);
    return AzureAuth;
})();
let IdpAuth = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let IdpAuth = class IdpAuth extends VuexModule {
        constructor() {
            super(...arguments);
            //  private userManager: UserManager = idpUsermanager;
            this.tokenResult = null;
            this.isAuthenticated = false;
            this.isExpired = false;
            this.isAboutExpired = false;
            this.authenticationResult = undefined;
            this.user = undefined;
            this.expiredOn = null;
            this.fullName = "";
            this.email = "";
            this.loginAnalytics = [];
            this.loggedIn = 0;
            this.notLoggedIn = 0;
            this.totalUsers = 0;
            this.totalLogins = 0;
            this.totalUserCount = 0;
            this.appUrl = settings.post_logout_redirect_uri;
        }
        getUser() {
            return idpUsermanager.getUser();
        }
        SetAuthentication(isAuthenticated) {
            let tokenResult1 = jwt_decode(this.user.access_token);
            let exp = this.user.expires_at;
            var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
            d.setUTCSeconds(exp);
            this.expiredOn = d;
            this.fullName = this.user.profile.given_name;
            this.email = this.user.profile.name;
            this.isAuthenticated = isAuthenticated;
        }
        SetUser(user) {
            this.user = user;
        }
        async Login() {
            const user = await idpUsermanager.getUser();
            if (user && !user.expired) {
                this.SetUser(user);
                this.SetAuthentication(true);
                return user;
            }
            return idpUsermanager.signinRedirect();
        }
        async LoginSilent() {
            const user = await idpUsermanager.signinSilent();
            if (user && !user.expired) {
                console.log(user.access_token);
                this.SetUser(user);
                this.SetAuthentication(true);
                return user;
            }
            else {
                this.SetAuthentication(false);
            }
        }
        Logout() {
            return idpUsermanager.signoutRedirect();
        }
        SessionTimeout() {
            return idpUsermanager.signoutRedirect({ post_logout_redirect_uri: settings.post_logout_redirect_uri + "sessiontimeout" });
        }
        get accessToken() {
            if (this.user && !this.user.expired) {
                return this.user.access_token;
            }
            return null;
        }
        get userIdValue() {
            return this.user.profile.sub;
        }
        sessionExpired() {
            window.localStorage.clear();
            window.sessionStorage.clear();
            router.push({ path: "/sessiontimeout" });
            return null;
        }
        getExpiresAtToken() {
            return new Promise((resolve, reject) => {
                idpUsermanager
                    .getUser()
                    .then((user) => {
                    if (user == null) {
                        resolve(null);
                    }
                    resolve(user.expires_at);
                })
                    .catch((err) => {
                    reject(new Error("failed"));
                });
            });
        }
        get expiresOn() {
            var date = new Date();
            return date;
        }
        get expiresInMinutes() {
            if (this.authenticationResult && this.authenticationResult.accessToken) {
                const diffInMilliseconds = Math.abs(this.authenticationResult.expiresOn.getTime() - new Date().getTime());
                console.warn(Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000) + " minutes to expiry");
                return () => Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000); // minutes
            }
            return () => -1;
        }
        async signinPopupCallback() {
            const user = await idpUsermanager.signinPopupCallback(window.location.href.split("?")[1]);
        }
        async SaveUserLoginDetails(userLoginDetials) {
            var url = `/UserLoginAnalytics/saveUserLogin`;
            let { data } = await service.post(url, userLoginDetials);
            return data;
        }
        async GetUserLoginAnalytics(payLoad) {
            var url = `/UserLoginAnalytics/analytics/` + payLoad.tenantId + `/` + payLoad.newDate;
            let { data } = await service.post(url, payLoad.searchData);
            if (data) {
                this.setLoginAnalytics(data);
            }
            return data;
        }
        setLoginAnalytics(analytics) {
            this.loginAnalytics = analytics.userLoginDetails;
            this.loggedIn = analytics.loggedIn;
            this.notLoggedIn = analytics.notLoggedIn;
            this.totalUsers = analytics.totalUsers;
            this.totalLogins = analytics.totalLogins;
            this.totalUserCount = analytics.totalUserCount;
        }
        ClearLoginAnalytics() {
            this.loginAnalytics = [];
            this.loggedIn = 0;
            this.notLoggedIn = 0;
            this.totalUsers = 0;
            this.totalLogins = 0;
            this.totalUserCount = 0;
        }
    };
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], IdpAuth.prototype, "SetAuthentication", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], IdpAuth.prototype, "SetUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], IdpAuth.prototype, "Login", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], IdpAuth.prototype, "LoginSilent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], IdpAuth.prototype, "Logout", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], IdpAuth.prototype, "SessionTimeout", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], IdpAuth.prototype, "signinPopupCallback", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof IUserLoginDTO !== "undefined" && IUserLoginDTO) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], IdpAuth.prototype, "SaveUserLoginDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], IdpAuth.prototype, "GetUserLoginAnalytics", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], IdpAuth.prototype, "setLoginAnalytics", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], IdpAuth.prototype, "ClearLoginAnalytics", null);
    IdpAuth = __decorate([
        Module({ dynamic: true, store: store, name: "idpauth", namespaced: true })
    ], IdpAuth);
    return IdpAuth;
})();
export const AuthModule = getModule(IdpAuth);
//export const AuthModule = getModule(AzureAuth);
